(function () {
  'use strict';

  var activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: activeCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function initQtySelector(selectorEl) {
    var formId = selectorEl.dataset.formId;
    var form   = document.getElementById(formId);
    if (!form) return;

    var variantInput      = form.querySelector('input[name="id"]');
    var priceEl           = document.querySelector('.price-item--regular');
    var priceContainer    = priceEl ? priceEl.parentElement : null;
    var whatsIncludedList = document.querySelector('.pdp-whats-included__list');

    var options      = Array.from(selectorEl.querySelectorAll('.s-qty-selector__option'));
    var variantCache = {};   // handle → variant id
    var priceCache   = {};   // handle → price in cents (from product.js)

    // Fetch variant ID and price for every option product
    options.forEach(function (btn) {
      var handle = btn.dataset.handle;
      if (!handle) return;

      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('fetch failed for ' + handle);
          return r.json();
        })
        .then(function (data) {
          variantCache[handle] = data.variants[0].id;
          priceCache[handle]   = data.price; // cents, already Markets-converted

          // Refresh whichever option is selected — compare price depends on
          // option 1's fetched price, so any completed fetch may unblock it
          var selectedBtn = selectorEl.querySelector('.s-qty-selector__option.is-selected');
          if (selectedBtn) refreshPriceDisplay(selectedBtn);
        })
        .catch(function (err) {
          console.warn('[qty-selector]', err.message);
        });
    });

    function refreshPriceDisplay(btn) {
      var handle      = btn.dataset.handle;
      var priceCents  = priceCache[handle];
      var optionIndex = options.indexOf(btn); // 0-based

      // --- Main price ---
      if (priceEl) {
        if (priceCents != null) {
          priceEl.textContent = formatMoney(priceCents);
        } else if (btn.dataset.price) {
          // Fetch not yet resolved — show hardcoded fallback briefly
          priceEl.textContent = btn.dataset.price;
        }
      }

      // --- Compare-at (strikethrough) price ---
      // Computed as optionNumber × option-1-price, fully from fetched data
      if (priceContainer) {
        var existingCompare  = priceContainer.querySelector('.s-price-compare');
        var option1Handle    = options[0] ? options[0].dataset.handle : null;
        var option1Cents     = option1Handle ? priceCache[option1Handle] : null;
        var compareCents     = (optionIndex > 0 && option1Cents != null)
          ? option1Cents * (optionIndex + 1)
          : null;

        if (compareCents != null) {
          if (!existingCompare) {
            existingCompare = document.createElement('s');
            existingCompare.className = 's-price-compare';
            priceContainer.insertBefore(existingCompare, priceEl);
          }
          existingCompare.textContent = formatMoney(compareCents);
        } else if (existingCompare) {
          existingCompare.remove();
        }
      }
    }

    function applyOption(btn) {
      options.forEach(function (o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');

      var handle = btn.dataset.handle;
      var wi1    = btn.dataset.wi1;
      var wi2    = btn.dataset.wi2;

      refreshPriceDisplay(btn);

      if (whatsIncludedList) {
        var items = [wi1, wi2].filter(Boolean);
        whatsIncludedList.innerHTML = items
          .map(function (t) { return '<li>' + t + '</li>'; })
          .join('');
      }

      if (variantInput && variantCache[handle]) {
        variantInput.value = variantCache[handle];
      }
    }

    options.forEach(function (btn) {
      btn.addEventListener('click', function () { applyOption(btn); });
    });
  }

  function init() {
    document.querySelectorAll('.s-qty-selector').forEach(function (el) {
      if (el.dataset.qtyInit) return;
      el.dataset.qtyInit = '1';
      initQtySelector(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
